/* eslint-disable no-restricted-globals */
import {
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonImg,
  IonModal,
  IonPage,
  IonRow,
} from "@ionic/react";
import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import QuestionIcon from "../assets/images/question-mark-icon.png";
import FloorTape from "../components/modals/floor-tape";
import MeasuringTape from "../components/modals/measuring-tape";
import TripodStand from "../components/modals/tripod-stand";
import tripodIcon from "../assets/images/tripod_stand.png";
import tableIcon from "../assets/images/table.png";
import paperIcon from "../assets/images/paper.png";
const EquipmentNeeded: React.FC = () => {
  const [measuringModal, setShowModal] = useState(false);
  const [tripodModal, setShowModal1] = useState(false);
  const [floorModal, setShowModal2] = useState(false);
  let history = useHistory();
  return (
    <IonPage placeholder={undefined}>
      <IonModal
        className="assessment-tape-modal-wrap"
        backdropDismiss={false}
        isOpen={measuringModal}
        placeholder={undefined}
      >
        <MeasuringTape setShowModal={setShowModal}></MeasuringTape>
      </IonModal>
      <IonModal
        className="assessment-tape-modal-wrap"
        backdropDismiss={false}
        isOpen={tripodModal}
        placeholder={undefined}
      >
        <TripodStand setShowModal1={setShowModal1}></TripodStand>
      </IonModal>
      <IonModal
        className="assessment-tape-modal-wrap"
        backdropDismiss={false}
        isOpen={floorModal}
        placeholder={undefined}
      >
        <FloorTape setShowModal2={setShowModal2}></FloorTape>
      </IonModal>
      <IonHeader
        className="ion-no-border phone-header-wraper-for-assessment-setup-pages"
        placeholder={undefined}
      >
        <div
          className="cross-icon"
          onClick={() => {
            history.push("/patient-page");
          }}
        >
          <svg
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.5 31C24.5081 31 31 24.5081 31 16.5C31 8.49187 24.5081 2 16.5 2C8.49187 2 2 8.49187 2 16.5C2 24.5081 8.49187 31 16.5 31Z"
              fill="white"
              stroke="#31344E"
              strokeWidth="3.22222"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.3332 21.3332L11.6667 11.6666"
              stroke="#31344E"
              strokeWidth="3.22222"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.3333 11.6666L11.6667 21.3333"
              stroke="#31344E"
              strokeWidth="3.22222"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="top-inner-sec">
                <div
                  className="left-arrow"
                  onClick={() => {
                    // localStorage.setItem("isOnAudioPage", "false")
                    //   history.push("")
                    history.push("/phone-audio-check");
                  }}
                >
                  <svg
                    className="svg-icons"
                    width="16"
                    height="26"
                    viewBox="0 0 16 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.8738 21.9379L5.75957 13.0063L14.8867 4.0621L14.8867 4.06211L14.8903 4.05847C15.706 3.24249 15.7059 1.92345 14.8738 1.10795C14.0466 0.297348 12.7153 0.297348 11.8881 1.10795L1.02777 11.7507C0.324078 12.4403 0.324078 13.5597 1.02777 14.2493L11.8881 24.892C12.7153 25.7027 14.0466 25.7027 14.8738 24.892C15.7066 24.0759 15.7066 22.754 14.8738 21.9379Z"
                      fill="#31344E"
                      stroke="black"
                    />
                  </svg>
                </div>
                <h1>Assessment Setup</h1>
                <p>
                  To properly setup and run this assessment, you will need the
                  following equipment.
                </p>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonHeader>
      <IonContent placeholder={undefined} className="slide-in-right">
        <IonGrid
          className="container inner-content-center"
          placeholder={undefined}
        >
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="equipment-pages-inner-sec-wrap">
                <h1>Required*</h1>
                <div className="equipment-pages-inner-sec">
                  <IonImg
                    onClick={() => setShowModal(true)}
                    src={QuestionIcon}
                    className="question-mark-icon"
                    placeholder={undefined}
                  ></IonImg>
                  <ul>
                    <li>
                      <IonImg
                        src={paperIcon}
                        alt="paperIcon"
                        placeholder={undefined}
                      ></IonImg>
                    </li>
                    <li>
                      <h2>8.5” x 11” PAPER</h2>
                    </li>
                  </ul>
                </div>
                <h6> Recommended</h6>
                <div className="equipment-pages-inner-sec">
                  <IonImg
                    src={QuestionIcon}
                    className="question-mark-icon"
                    onClick={() => setShowModal1(true)}
                    placeholder={undefined}
                  ></IonImg>
                  <ul>
                    <li>
                      <IonImg
                        src={tripodIcon}
                        alt="tripodIcon"
                        placeholder={undefined}
                      ></IonImg>
                    </li>
                    <li>
                      <h2>TRIPOD / STAND</h2>
                    </li>
                  </ul>
                </div>
                <div className="equipment-pages-inner-sec">
                  <IonImg
                    onClick={() => setShowModal2(true)}
                    src={QuestionIcon}
                    className="question-mark-icon"
                    placeholder={undefined}
                  ></IonImg>
                  <ul>
                    <li>
                      <IonImg
                        src={tableIcon}
                        alt="tableIcon"
                        placeholder={undefined}
                      ></IonImg>
                    </li>
                    <li>
                      <h2>DESK / TABLE</h2>
                    </li>
                  </ul>
                </div>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
      <IonFooter className="ion-no-border" placeholder={undefined}>
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="phone-footer-wraper-for-assessment-setup-pages">
                {/* <div className="dot-circles">
                  <ul>
                  <li className="active"><span className="test"></span></li>
                  <li><span className="test"></span></li>
                  <li><span className="test"></span></li>
                  <li><span className="test"></span></li>
                  </ul>
                </div> */}
                <ul className="base-timeline">
                  <li className="base-timeline-item active"> </li>
                  <li className="base-timeline-item active"></li>
                  <li className="base-timeline-item"></li>
                  <li className="base-timeline-item"></li>
                </ul>
                <div className="btn-wrap-sec">
                  {/* /phone-height-requirement */}
                  <Link
                    to="/phone-height-requirement"
                    className="ancher-generic-btn text-dec-none"
                  >
                    Continue
                  </Link>
                  {/* <IonButton className="generic-btn">Continue</IonButton> */}
                </div>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonFooter>
    </IonPage>
  );
};
export default EquipmentNeeded;
